import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotContentGrid from './components/HotContentGrid';
import FeatureMatrix from './components/FeatureMatrix';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotContentGrid />
        <FeatureMatrix />
        <CTASection />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: '91免费',
              url: 'https://www.91free.com',
              description: '91免费⚡看片视频网站与app下载入口集中页面，覆盖91免费在线视频、看片神器、麻豆网站资源，每日更新吃瓜黑料和网红实时追踪，直接在线观看。',
              potentialAction: {
                '@type': 'SearchAction',
                target: 'https://www.91free.com/search?q={search_term_string}',
                'query-input': 'required name=search_term_string',
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: '91免费',
              url: 'https://www.91free.com',
              description: '领先的娱乐八卦资讯平台',
              address: {
                '@type': 'PostalAddress',
                streetAddress: '建国路88号SOHO现代城A座',
                addressLocality: '北京',
                addressRegion: '朝阳区',
                addressCountry: 'CN',
              },
              contactPoint: {
                '@type': 'ContactPoint',
                telephone: '400-888-9191',
                contactType: 'customer service',
              },
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}